(() => {
  const query = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (query.matches || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver((entries, instance) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in-view');
        instance.unobserve(entry.target);
      }
    }
  }, { rootMargin: '0px 0px -5% 0px', threshold: 0.08 });
  function observe(root = document) {
    root.querySelectorAll('.bejjy-v2-reveal:not(.is-in-view)').forEach((element) => observer.observe(element));
    document.documentElement.classList.add('bejjy-motion-ready');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => observe(), { once: true });
  else observe();
  document.addEventListener('shopify:section:load', (event) => observe(event.target));
})();
document.addEventListener('click', (event) => {
  if (event.target.closest('[data-bejjy-nav-close]')) {
    const menu = event.target.closest('details');
    if (menu) menu.open = false;
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') document.querySelectorAll('.bejjy-mobile-nav[open]').forEach((menu) => { menu.open = false; });
});
